import { render, staticRenderFns } from "./ApprovalGroups.vue?vue&type=template&id=461760b0"
import script from "./ApprovalGroups.vue?vue&type=script&lang=js"
export * from "./ApprovalGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports